import { render, staticRenderFns } from "./CustomerDetail-customerActivities.vue?vue&type=template&id=84b82336&scoped=true"
import script from "./CustomerDetail-customerActivities.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-customerActivities.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-customerActivities.vue?vue&type=style&index=0&id=84b82336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b82336",
  null
  
)

export default component.exports